import * as THREE from "three";

export class AnimationHandler {

	mixers = []

	animationsMap = {};

	remove(model) {
		this.removeById(model.id)
	}

	removeById(modelID) {
		for (let i = 0; i < this.mixers.length; i++) {
			if (this.mixers[i].getRoot().id !== modelID)
				continue

			delete this.mixers[i]
			break
		}
	}

	addAnimatable(model, animations) {
		console.log("Animatable.buildAnimations", model.name, animations);
		const mixer = new THREE.AnimationMixer(model)

		animations.forEach((clip) => {
			const key = `${model.uuid}-${clip.name}`
			// console.log(`Animatable::Adding clip: ${key}`, clip)
			if (this.animationsMap[key]) {
				console.warn("Animatable::Animation already exists: ", key)
				return
			}

			this.animationsMap[key] = mixer.clipAction(clip)
			this.animationsMap[key].loop = THREE.LoopRepeat
		})

		if (Object.keys(this.animationsMap).length > 0) {
			// console.log("Terrain - Playing animation: ", animations[0].name)
			// this.animationsMap[`${model.uuid}-${animations[0].name}`].play() //Play first animation
		}

		// console.log("Terrain Animatable:", {
		// 	animations: animations,
		// 	mapper: this.animationsMap,
		// 	mixerRoot: mixer.getRoot()
		// })

		this.mixers.push(mixer)
	}

	play(alphaId, animationName) {
		this.animationsMap[`${alphaId}-${animationName}`].reset()
		this.animationsMap[`${alphaId}-${animationName}`].loop = THREE.LoopOnce
		this.animationsMap[`${alphaId}-${animationName}`].play() //Play first animation
	}

	stop(alphaId, animationName) {
		this.animationsMap[`${alphaId}-${animationName}`].stop() //Play first animation
	}

	update(delta) {
		for (const mixer of this.mixers) {
			mixer.update(delta)
		}
	}

	reset() {
		this.mixers = [];
		this.animationsMap = {};
	}
}